/**
 * Defines alert colour options.
 */
export enum AlertColour {
  Green = 'green',
  Amber = 'amber',
  Red = 'red',
}
